module.exports = __webpack_public_path__ + "img/intro_bg2.a7b05bc2.jpg";